<template>
  <div>
    <b-container style="margin-bottom: 100px; text-align: center">
      <b-container>
        <b-row align-h="around" class="margin-top">
          <b-col xs="2" sm="2" md="2" lg="3" xl="4"></b-col>
          <b-col xs="8" sm="8" md="8" lg="6" xl="4" :class="[overrideColor]">
            <b-alert :class="[getLanguageDirection,'login invalid']" v-show="show_invalid_credential_message" show variant="danger">
              <span>{{$t('msg.invalid_credentials')}}</span>
            </b-alert>
            <b-form @submit.prevent="handleSubmit" class="border text-center">

              <img src="../assets/ram.jpg"  class="d-inline-block align-top brandlogo" alt="logo"/>

              <b-form-group :class="[getLanguageDirection,'login']" id="user-name-input-group-1" style="margin-top:20px">
                <b-form-input v-model="username" name="username" v-validate="'required'"
                              id="username" type="text" @focus="changeState()"
                              :class="{'input': true, 'border-danger': errors.has('username') }"
                              :placeholder="$t('msg.username')"></b-form-input>

                <i v-show="errors.has('username')" class="fa fa-warning"></i>
                <span v-show="errors.has('username')" class="error">{{$t('msg.blank_username_field')}}</span>
              </b-form-group>

              <b-form-group :class="[getLanguageDirection,'login']" id="password-input-group-2" class="pt-3">
                <b-input type="password" v-model="password" name="password" id="password" v-validate="'required'"
                         @focus="changeState()"
                         :class="{'input': true, 'border-danger': errors.has('password') }"
                         :placeholder="$t('msg.password')"></b-input>
                <i v-show="errors.has('password')" class="fa fa-warning"></i>
                <span v-show="errors.has('password')" class="error">{{$t('msg.blank_password_field')}}</span>
              </b-form-group>

              <b-form-group :class="[getLanguageDirection,'login-button']" id="submit-group">
                <b-button :disabled="loggingIn" type="submit" variant="primary" class="button-size">
                  <b-spinner small v-show="loggingIn"></b-spinner>
                  {{$t('msg.enter') }}
                </b-button>
              </b-form-group>

              <b-container>
                <b-row align-h="around">
                  <b-col xs="12" class="text-center">
                    <b-link :href="getPdfFile" target="_blank">
                      {{$t('msg.user_guide') }}
                    </b-link>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>
          </b-col>
          <b-col xs="2" sm="2" md="2" lg="3" xl="4"></b-col>
        </b-row>

      </b-container>

    </b-container>
  </div>
</template>

<script>
import { apiUrl, rootUrl } from '../_config'
import { userService } from '../_services'

export default {
  data () {
    return {
      username: '',
      password: '',
      submitted: false,
      loggingIn: false,
      show_invalid_credential_message: false,
      overrideColor: '',
      pdfFilePath: '',
      userGuide: ''
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  methods: {
    changeState: function () {
      this.show_invalid_credential_message = false
    },
    handleSubmit: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loggingIn = true
          let meta
          if (window.location.pathname) { meta = window.location.pathname.split('/').pop() }

          if (!meta) { meta = 'ram' }

          userService.login(this.username, this.password, meta)
            .then(response => {
              this.loggingIn = false
              window.location.href = rootUrl() + 'home'
            }).catch(error => {
              this.loggingIn = false
              console.log(error)
              this.show_invalid_credential_message = true
            })
        }
      })
    },
    getProductBrandImageUrl: function () {
      return apiUrl() + 'media/logo/' + this.getBrandLogo()
    },
    getBrandLogo: function () {
      if (this.$cookies.get('product_logo') && this.$cookies.get('product_logo').trim() !== '') {
        return this.$cookies.get('product_logo')
      }
      return undefined
    }
  },
  computed: {
    getLanguageDirection () {
      if (this.$store.state.home.isRTL) { return 'rtl' } else { return 'ltr' }
    },
    getPdfFile () {
      if (this.$store.state.home.language === 'en') {
        return 'https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/gfi_ram_en.pdf'
      } else if (this.$store.state.home.language === 'ms') {
        return 'https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/gfi_ram_ms.pdf'
      } else {
        return 'https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/gfi_ram_en.pdf'
      }
    }
  },
  created: function () {
    let pageTitle = ''
    if (this.$cookies.get('product_name') && this.$cookies.get('product_name').trim() !== '') {
      pageTitle = this.$cookies.get('product_name')
    }
    document.title = pageTitle
    if (this.$cookies.get('override_color') && this.$cookies.get('override_color').trim() !== '') {
      this.overrideColor = this.$cookies.get('override_color')
    }
    /* if (this.$cookies.get('user_guide') && this.$cookies.get('user_guide').trim() !== '') {
      this.userGuide = this.$cookies.get('user_guide')
    } */
  }
}
</script>

<style>

  .rtl.login-button {
    direction: rtl;
  }

  .rtl.login {
    direction: rtl;
    text-align: right;
  }

  .rtl.login .error {
    direction: rtl;
    text-align: right;
    float: right;
  }

  .border {
    border: 1px solid black;
    background: rgba(255, 255, 255, .75);
    box-shadow: 1px 2px 10px -1px;
    margin-top: 10px;
    padding: 30px;
    /*height: 300px;*/
  }

  .button-size {
    margin-top: 50px;
    width: 80%;
  }

  .help .is-danger {
    color: red;
  }

  .borderColor {
    border-color: red;
  }

  .error {
    color: #f22435;
    font-size: 12px;
    float: left;
  }

  .invalid {
    font-size: 14px;
  }

  .brandlogo {
    max-height: 150px;
    max-width: 275px;
  }

  .bnm .border {
    border: 1px solid black;
    background: rgba(109, 123, 144,.54);
    box-shadow: 1px 2px 10px -1px;
    margin-top: 10px;
    padding: 30px;
  }

  .bnm .btn-primary {
    color: #fff;
    background-color: #0A317A;
    border-color: #0A317A;
  }

  .bnm .btn-primary:hover {
    color: #fff;
    background-color: #0A317A;
    border-color: #0A317A;
  }

  @media screen and (min-width: 320px) and (max-width: 992px) {
    .brandlogo {
      max-height: 85px;
      max-width: 220px;
    }
  }
</style>

<style scoped>

  .margin-top {
    margin-top: 100px;
  }

  @media screen and (min-height: 601px) and (max-height: 720px) {
    .margin-top {
      margin-top: 30px;
    }
  }

  @media screen and (max-height: 600px) {
    .margin-top {
      margin-top: 10px;
    }
  }

</style>
